import { produce } from 'immer'
import {
    SET_APPLICATION_OFFERS_LIST,
    SET_APPLICATION_OFFER_DETAIL,
    SET_APPLICATION_OFFER_AVAILABLE_SUMMARY,
    SET_APPLICATION_OFFER_SUMMARY,
    SET_APPLICATION_OFFER_OWNER_SUMMARY
} from 'actions/applicationOffers'

const initialState = {
    applicationOffersList: [],
    totalRecords: 0,
    totalPages: 0,
    applicationOfferDetail: null,
    availableSummary: null,
    summaryData: null,
    ownerSummaryData: null
}

const applicationOffersReducer = produce((draft, action) => {
    switch (action.type) {
        case SET_APPLICATION_OFFERS_LIST:
            draft.applicationOffersList = action.payload.applicationOffers
            draft.totalRecords = action.payload.totalRecords
            draft.totalPages = action.payload.totalPages
            break
        case SET_APPLICATION_OFFER_DETAIL:
            draft.applicationOfferDetail = action.payload
            break
        case SET_APPLICATION_OFFER_AVAILABLE_SUMMARY:
            draft.availableSummary = action.payload
            break
        case SET_APPLICATION_OFFER_SUMMARY:
            draft.summaryData = action.payload
            break
        case SET_APPLICATION_OFFER_OWNER_SUMMARY:
            draft.ownerSummaryData = action.payload
            break
        default:
            return draft
    }
}, initialState)

export default applicationOffersReducer